import * as React from "react";
import * as ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import App from "./app/App";
import "./index.scss";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { ldProviderConfig } from "./helpers/launchDarklyHelpers";
import { getLdFlags } from "./api";
import { logError } from "./helpers";
import { ApiError } from "./helpers/errors";

/** @ignore import registerServiceWorker from "./registerServiceWorker"; */

(async () => {
  const config = ldProviderConfig;

  try {
    const bootstrapFlags = await getLdFlags();

    if (bootstrapFlags) {
      const { flags } = bootstrapFlags;

      config.options.bootstrap = flags;
    }
  } catch (e) {
    logError("Unable to retrieve LD bootstrap flags", e as ApiError);
  } finally {
    const LDProvider = await asyncWithLDProvider(config);

    ReactDOM.render(
      <LDProvider>
        <Router>
          <App />
        </Router>
      </LDProvider>,
      document.getElementById("mpf-root") as HTMLElement
    );
  }
})();
/* @ignore registerServiceWorker();

// Unregister Service Workers, if present
navigator.serviceWorker.getRegistrations().then(registrations => {
  for (const registration of registrations) {
    registration.unregister();
  }
}); */
